import { AccordionCollapse } from "Components/AccordionCollapse";

interface DetailSectionProps {
  sectionTitle: string;
  fields: {
    name: string;
    value: string[] | number[];
  }[];
}

export const DetailSection = ({ fields, sectionTitle }: DetailSectionProps) => {
  return (
    <AccordionCollapse title={sectionTitle} cssClass="lg-12">
      <div className="accordion-items">
        {fields.map((field, index) => (
          <div className="order-item" key={index}>
            <p>{field.name}</p>
            {field.value.map((f) => (
              <span style={{ display: "block" }} key={f}>
                {f || "Não informado"}
              </span>
            ))}
          </div>
        ))}
      </div>
    </AccordionCollapse>
  );
};
